// Setup the namespace for this logic
var readOnlyRosterListPreventer = readOnlyRosterListPreventer || {};


// If the whole workitem isn't readonly, then don't display this page as readonly, regardless of the fields
//   that are included in the "Add New Roster" portion of the page.
readOnlyRosterListPreventer.paint = function(readOnlyIndicatorFieldId) {
	var workitemReadOnlyField = page.getField(readOnlyIndicatorFieldId); //"OptionalCoverageWorkitemReadOnly");
	if (page.readOnly && page.type=="roster" && workitemReadOnlyField!=null) {
		var workitemReadOnly = workitemReadOnlyField.getDefaultValue();
		if (workitemReadOnly!="YES") {
			page.readOnly = false;
		}
	}
};